export const SPECIAL_SYMBOL_LIST = ['\\s', '\\.', '\\n', '&', '"', "'", '·', ',', ';', ':', '‐', '\\-', '(', ')'];
